import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const Disclaimer = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Button 
          onClick={() => navigate('/')}
          variant="ghost"
          className="mb-8"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Zurück zur Startseite
        </Button>

        <div className="prose prose-slate max-w-none">
          <h1>Disclaimer / Haftungsausschluss</h1>

          <h2>1. Inhalt des Onlineangebotes</h2>
          <p>
            Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität 
            der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich auf Schäden 
            materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen 
            Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, 
            sind grundsätzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vorsätzliches oder grob 
            fahrlässiges Verschulden vorliegt.
          </p>
          <p>
            Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile 
            der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen 
            oder die Veröffentlichung zeitweise oder endgültig einzustellen.
          </p>

          <h2>2. Verweise und Links</h2>
          <p>
            Bei direkten oder indirekten Verweisen auf fremde Webseiten ("Hyperlinks"), die außerhalb des 
            Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall 
            in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar 
            wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern.
          </p>
          <p>
            Der Autor erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf 
            den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder 
            die Urheberschaft der verlinkten/verknüpften Seiten hat der Autor keinerlei Einfluss. Deshalb distanziert 
            er sich hiermit ausdrücklich von allen Inhalten aller verlinkten/verknüpften Seiten, die nach der 
            Linksetzung verändert wurden.
          </p>

          <h2>3. Urheber- und Kennzeichenrecht</h2>
          <p>
            Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Bilder, Grafiken, 
            Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Bilder, Grafiken, 
            Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, 
            Videosequenzen und Texte zurückzugreifen.
          </p>
          <p>
            Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen 
            unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten 
            der jeweiligen eingetragenen Eigentümer.
          </p>

          <h2>4. Datenschutz</h2>
          <p>
            Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder geschäftlicher Daten 
            (E-Mail-Adressen, Namen, Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens des Nutzers 
            auf ausdrücklich freiwilliger Basis. Die Inanspruchnahme und Bezahlung aller angebotenen Dienste ist – 
            soweit technisch möglich und zumutbar – auch ohne Angabe solcher Daten bzw. unter Angabe anonymisierter 
            Daten oder eines Pseudonyms gestattet.
          </p>

          <h2>5. Rechtswirksamkeit</h2>
          <p>
            Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese Seite 
            verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, 
            nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Dokumentes in ihrem 
            Inhalt und ihrer Gültigkeit davon unberührt.
          </p>

          <h2>6. Keine Erfolgsgarantie</h2>
          <p>
            Die auf dieser Website dargestellten Dienstleistungen und Ergebnisse stellen keine Garantie für bestimmte 
            Erfolge dar. Die tatsächlichen Ergebnisse können variieren und hängen von verschiedenen Faktoren ab, 
            einschließlich der aktiven Mitarbeit des Kunden, Marktbedingungen und der Zielgruppe.
          </p>

          <p className="mt-8">
            <strong>2besales GmbH</strong><br />
            Lena-Christ-Str. 2<br />
            82031 Grünwald<br />
            E-Mail: info@2besales.de
          </p>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
